module.exports = __webpack_public_path__ + "img/ic_user.96f12fd8.svg";